import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'flash_sales-sale_announcement_tooltip-click';
/**
 * Tracks clicks on sale announcement tooltip cta
 */
export function trackFlashSalesSaleAnnouncementTooltipClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
